export default __webpack_public_path__ + "img/fegirzYG.07cabc00.svg";